export default __webpack_public_path__ + "static/5-0f0ce5c9fb6f492a45d97e32e3c6f900.png";